import React from 'react'
import Field from '../common/Field'
import i18n from 'i18n'

const WeFitterHeartRateSampleDetails = (props) => {
  const sdos = props.data.structured_data_objects
  if (!sdos || sdos.length < 1) return <></>

  const dataRows = sdos[0].data_rows
  const first = (dataRows && dataRows.length > 0) ? dataRows[0] : {}
  const value = (first.value !== undefined && first.value !== null) ? first.value : 'N/A'
  const min = (first.min !== undefined && first.min !== null) ? first.min : 'N/A'
  const max = (first.max !== undefined && first.max !== null) ? first.max : 'N/A'

  return (
    <div className='sport-fields'>
      <Field key='value' title={i18n.t('components.we_fitter.heart_rate_sample_details.value')} value={`${value} bpm`} />
      <Field key='min_hr' title={i18n.t('components.we_fitter.heart_rate_sample_details.min_hr')} value={`${min} bpm`} />
      <Field key='max_hr' title={i18n.t('components.we_fitter.heart_rate_sample_details.max_hr')} value={`${max} bpm`} />
    </div>
  )
}

export default WeFitterHeartRateSampleDetails
